import theme from '@/config/theme'
import Vuetify from '@/plugins/vuetify'

export default {
  namespaced: true,
  state: {
    preview: false
  },
  mutations: {
    setPreview: (state, value) => state.preview = value
  },
  actions: {
    async startPreview ({commit}, color) {
      commit('setPreview', true)
      Vuetify.framework.theme.themes.light.primary = color
      
      setTimeout(() => {
        commit('setPreview', false)
        Vuetify.framework.theme.themes.light.primary = theme.primary
      }, 10000);
    },

    // Restore the base theme color
    async restore () {
      Vuetify.framework.theme.themes.light.primary = theme.primary
    },

    // Apply the custom color theme
    async apply (_, color) {
      Vuetify.framework.theme.themes.light.primary = color
    }
  }
}